const guIN= {
    login: {
      title: 'સાઇન ઇન',
      sign_in_btn: 'સાઇન ઇન'
    },
    bar: {
        logout: 'લોગ આઉટ',
        languages: 'ભાષાઓ',
        settings: 'સેટિંગ્સ ખોલો'
    },
    language: {
      name: 'અંગ્રેજી (યુએસ)',
    },
    attributePage: {
        title: 'લાક્ષણિકતાઓના ફેરફાર',
        viewChanges: 'ફેરફારો જુઓ',
        dateTime: 'તારીખ',
        notificationType: 'નોટિફિકેશનનો પ્રકાર',
        notificationValue: 'નોટિફિકેશનનું મૂલ્ય',
        oldValue: 'જૂનું મૂલ્ય',
        newValue: 'નવું મૂલ્ય',
        accept: 'સ્વીકારો',
        reject: 'નકારો',
    },
    Home: 'હોમ',
    load: 'પ્રારંભિક લોડ થાય છે...',
    Requested: "વિનંતી કરેલ",
    Viewed: "જોયેલ",
    Executing: "એક્ઝિક્યુટ થાય છે",
    Completed: "પૂર્ણ",
    Expired: "સમયસીમા સમાપ્ત થઈ",
    Cancelled: "રદ કરેલ",
    Error: "એરર",
    Rejected: "નકારેલ",
    error: 'કંઈક ખોટું થયું; પછીથી ફરી પ્રયાસ કરવા વિનંતી.',
    displayname: 'ડિસ્પ્લે નામ',
    givenname: 'નામ',
    surname: 'અટક',
    email: 'ઇમેઇલ',
    mail: 'ઇમેઇલ',
    name: 'નામ',
    firstname: 'નામ',
    lastname: 'અટક',
    footer_copyright: 'સર્વ હક સ્વાધીન.'
  };
  
  export default guIN;
  